import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Oval } from 'react-loader-spinner';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Success } from 'assets/icons/success.svg';

interface PreparingUserModalProps {
	isOpen: boolean;
	onClose: () => void;
	isPreparing: boolean;
}

export const PreparingUserModal: FC<PreparingUserModalProps> = ({
	isOpen,
	onClose,
	isPreparing,
}) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const handleClose = () => {
		if (!isPreparing) {
			onClose();
		}
	};

	return (
		<InfoModal
			isOpen={isOpen}
			onClose={handleClose}
			image={
				!isPreparing ? (
					<Success />
				) : (
					<Oval
						height={60}
						width={60}
						color="#9FA6B3"
						wrapperStyle={{}}
						wrapperClass=""
						visible={true}
						ariaLabel="oval-loading"
						secondaryColor="#9FA6B3"
						strokeWidth={5}
						strokeWidthSecondary={5}
					/>
				)
			}
			title={
				!isPreparing
					? modalTranslate('preparingUserModal.titleResult')
					: modalTranslate('preparingUserModal.title')
			}
			description={
				!isPreparing
					? modalTranslate('preparingUserModal.descriptionResult')
					: modalTranslate('preparingUserModal.description')
			}
			buttons={<></>}
		></InfoModal>
	);
};
